import { useContext, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import {
  DATE_FORMAT_DD_MM_HH_MM,
  formatDate,
  formatPlateBR,
} from "../../../helpers/util";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";
import OrderVehicleModal from "./OrderVehicleModal";
import { GlobalContext } from "../../../contexts/global";

export default function PlateOrdered({
  licensePlate,
  orderVehicle,
  elapsedTime,
}) {
  const { setShowAlert, showAlert } = useContext(GlobalContext);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  const onPressCancel = () => {
    setShowAlert({
      type: "warning",
      title: "Atenção",
      message: `Deseja cancelar o pedido do veículo veículo ${formatPlateBR(
        licensePlate
      )}?\nEssa ação é permanente.`,
      show: true,
      confirmText: "Sim",
      cancelText: "Não",
      pressCancel: () => {
        setShowAlert({ ...showAlert, show: false });
      },
      pressConfirm: () => {
        setShowAlert({ ...showAlert, show: false });
      },
    });
  };

  const InfoView = ({ title, value }) => (
    <View style={styles.infoView}>
      <Text style={styles.titleText}>{title}</Text>
      <Text style={styles.plateText}>{value}</Text>
    </View>
  );

  const InfoButton = ({ onPress, iconName, buttonColor, buttonStyle }) => {
    return (
      <TouchableOpacity
        style={[
          styles.infoButton,
          { backgroundColor: buttonColor },
          buttonStyle,
        ]}
        onPress={onPress}
      >
        <Icon name={iconName} size={24} color={Colors.WHITE} />
      </TouchableOpacity>
    );
  };

  return (
    <View style={styles.principalView}>
      <View style={styles.subView}>
        <View style={styles.topView}>
          <Icon name="car-outline" size={24} />
          <InfoView title={"Placa"} value={formatPlateBR(licensePlate)} />
          <InfoView
            title={"Dt. Pedido"}
            value={formatDate(orderVehicle.dtRequest, DATE_FORMAT_DD_MM_HH_MM)}
          />
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              marginLeft: "auto",
              marginHorizontal: 8,
            }}
          >
            <InfoButton
              iconName={"information-outline"}
              buttonColor={Colors.PRIMARY}
              onPress={toggleModal}
            />
            {/* <InfoButton
              iconName={"window-close"}
              buttonColor={Colors.SECONDARY}
              buttonStyle={{ marginLeft: 4 }}
              onPress={onPressCancel}
            /> */}
          </View>
        </View>
      </View>
      <View
        style={[
          styles.statusView,
          { backgroundColor: orderVehicle.nmStatusColor },
        ]}
      >
        <Text style={styles.statusText}>{orderVehicle.nmStatus}</Text>
      </View>
      <View style={[styles.line, { width: `${(elapsedTime / 60) * 100}%` }]} />
      <OrderVehicleModal
        isVisible={isModalVisible}
        orderVehicle={orderVehicle}
        onClose={toggleModal}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  principalView: {
    borderRadius: 8,
    marginVertical: 8,
    padding: 8,
    backgroundColor: Colors.SNOW,
    borderColor: Colors.SECONDARY,
    borderLeftWidth: 2,
    shadowColor: Colors.GRAY_DARK,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    borderRadius: 8,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  subView: {
    flexDirection: "row",
    alignItems: "center",
    alignItems: "center",
  },
  infoView: {
    marginHorizontal: 8,
  },
  titleText: {
    fontSize: Fonts.FONT_SIZE_16,
    fontWeight: "300",
    color: Colors.BLACK,
  },
  plateText: {
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "500",
    color: Colors.SECONDARY,
  },
  statusView: {
    borderRadius: 6,
    backgroundColor: Colors.PRIMARY,
    padding: 8,
    marginHorizontal: 8,
    marginVertical: 8,
    alignItems: "center",
    shadowColor: Colors.GRAY_DARK,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  statusText: {
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "500",
    color: Colors.WHITE,
  },
  line: {
    height: 4,
    backgroundColor: Colors.PRIMARY,
    borderRadius: 4,
    marginTop: 4,
  },
  topView: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    alignItems: "center",
  },
  infoButton: {
    marginLeft: "auto",
    padding: 8,
    borderRadius: 4,
    shadowColor: Colors.GRAY_DARK,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
});
